export default __webpack_public_path__ + "static/media/include_5_female@2x.8f46dde4.jpg";